import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Integrations16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_361)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.18756 5.87316L10.1269 6.8125L8.96973 7.96967L10.0304 9.03033L11.1876 7.87316L12.3751 9.06068L15.1769 6.2589C15.665 5.77074 15.665 4.97929 15.1769 4.49113L13.8732 3.18745L15.5303 1.53034L14.4696 0.469683L12.8125 2.12679L11.509 0.823239C11.0208 0.335084 10.2293 0.335084 9.74119 0.823239L6.93942 3.62502L8.1269 4.8125L6.96973 5.96967L8.03039 7.03033L9.18756 5.87316ZM13.9394 5.37502L12.3751 6.93936L9.06074 3.62502L10.6251 2.06068L13.9394 5.37502Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.18749 13.8732L4.49104 15.1768C4.9792 15.6649 5.77065 15.6649 6.25881 15.1768L9.06059 12.375L3.62492 6.93934L0.823148 9.74112C0.334992 10.2293 0.334993 11.0207 0.823148 11.5089L2.12683 12.8126L0.469727 14.4697L1.53039 15.5303L3.18749 13.8732ZM2.06058 10.625L3.62492 9.06066L6.93926 12.375L5.37492 13.9393L2.06058 10.625Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_361'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Integrations16.displayName = 'Integrations16';
export default Integrations16;
